<template>
<div class="chapter">
<div class="inner_page">
<p class="fmhead"><a id="ack"></a><a id="page_ix"></a>Acknowledgments</p>
<p class="para">We are grateful to Sarah Grew for her generosity in providing the photographic images and to Nancy Fedrow for her assistance in preparing the manuscript. We want especially to thank our friend and editor Dee Mortensen for the encouragement and advice she has so generously offered us during our collaboration on this project. Thanks also to Sean Driscoll for editorial assistance.</p>
<p class="fm-right">J. S.<br/>A.V.<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?adee6624